
export const PDF_CONFIG = {
  pageWidth: 210, // A4 width in mm
  pageHeight: 297, // A4 height in mm
  margin: 20,
  fonts: {
    sizes: {
      title: 24,
      subtitle: 12,
      sectionTitle: 16,
      categoryTitle: 14,
      content: 9,
      footer: 8
    }
  }
};

export const PDF_COLORS: Record<string, [number, number, number]> = {
  primary: [102, 51, 153], // Purple
  secondary: [59, 130, 246], // Blue
  text: [31, 41, 55], // Gray-800
  lightGray: [243, 244, 246], // Gray-100
  accent: [168, 85, 247], // Purple-500
  white: [255, 255, 255]
};

export const CATEGORY_COLORS: Record<string, [number, number, number]> = {
  overview: [147, 51, 234], // Purple
  traits: [59, 130, 246], // Blue
  psychology: [16, 185, 129], // Emerald
  clinical: [245, 101, 101], // Red
  recommendations: [236, 72, 153] // Pink
};

export const CATEGORY_TITLES = {
  overview: 'VISÃO GERAL',
  traits: 'ANÁLISE DE TRAÇOS',
  psychology: 'PSICOLOGIA PROFUNDA',
  clinical: 'ASPECTOS CLÍNICOS',
  recommendations: 'RECOMENDAÇÕES'
};
